module.exports = __webpack_public_path__ + "static/media/iso9001.7b94fa09.jpg";